import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';

@Component({
  selector: 'cv-configure-name',
  templateUrl: './configure-name.component.html',
  styleUrls: ['./configure-name.component.scss']
})
export class ConfigureNameComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;
  @Input() isCxone: boolean = false;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  message: string = "";
  specials: RegExp = /[\\/!+<>?#&,%]/;

  constructor(
    private gamesService: GamesService
  ) { 
    this.gs = this.gamesService.data 
  }

  ngOnInit(): void { }

  checkComponent(): void {
    this.message = "";

    let msg = (key, fallback) => {
        return this.gamesService.getValidationMessage(key, fallback);
    };

    //Check if the name is not duplicated on new or copy games
    const isNameDuplicated = this.gs.games.some((game: any) => {
      return game.underlyingRule.RuleName.toUpperCase() === this.gs.modified.item.underlyingRule.RuleName.toUpperCase() &&
            (game.underlyingRule.RuleID !== this.gs.modified.item.underlyingRule.RuleID);
    });

    if (isNameDuplicated) {
      this.message = msg("Game_Name_Duplicated", "The name of this game has already been taken.");
    }

    //Check if the name has one of the restricted characteres
    if (this.specials.test(this.gs.modified.item.underlyingRule.RuleName)) {
      this.message = msg("Game_Invalid_Characters", "The following characters are not permitted: \ / ! + < > ? # & , %");
    }

    if (this.gs.modified.item.underlyingRule.RuleName === "" || this.gs.modified.item.underlyingRule.RuleName === " "){
      this.message = msg("Game_Name_Required", "You haven't input a name for the game.");
    }  

    if (this.message === "" || this.isCxone) {
      var eventArgs = {
        currentStep: this.step - 1,
        unlocks: this.componentOptions.unlocks
      };
      this.componentComplete.emit(eventArgs);
    }
  }
}
